import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { RouterModule } from '@angular/router';
import { of, tap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserRepository } from '../../repositories/user/user.repository';
import { authRoutes } from './auth.routes';
import { AuthService } from './auth.service';
import { provideOktaCore } from './okta/okta.provider';

export const provideAuthCore = () => [
  provideOktaCore(),
  importProvidersFrom(RouterModule.forChild(authRoutes)),
  {
    provide: APP_INITIALIZER,
    useFactory: (userRepository: UserRepository, authService: AuthService) => () => {
      // Logged-in user when app start. If token not valid, login() return error and user don't connected
      return userRepository.login().pipe(
        tap((user) => authService.loggedUser(user)),
        catchError(() => of(false)),
      );
    },
    deps: [UserRepository, AuthService],
    multi: true,
  },
];
